/** Prevents a slower, older asynchronous input from superseding a newer user action. */
export class LatestUserActionGuard {
  private generation = 0

  begin(): number {
    this.generation += 1
    return this.generation
  }

  isCurrent(requestGeneration: number): boolean {
    return requestGeneration === this.generation
  }

  cancel(): void {
    this.generation += 1
  }
}

/** Shared across text, legacy, and VAD send paths so the latest user action wins. */
export const latestUserActionGuard = new LatestUserActionGuard()
